<div
  class="modal {{ info.type }} {{ info.extraCssClass }}"
  [ngClass]="{
    'static-height': info.static?.height,
    'with-actions': info.actions,
    'single-description': info.header?.singleDescription,
    'bg-image': info?.backgroundImage,
  }"
  appModal
  [staticHeight]="info.static?.height"
  [staticTitle]="info.static?.title"
  [staticText]="info.static?.text"
  [style.width]="info.fixed?.width ? info.fixed?.width + 'px' : null"
  [style.height]="info.fixed?.height ? info.fixed?.height + 'px' : null"
  [style.background-image]="info?.backgroundImage ? 'url(' + info.backgroundImage + ')' : null">
  @if (info?.extraCssClass === 'beta-modal') {
    <app-feature-tag
      tagType="beta"
      tagSize="medium"
      [translateTagX]="640"
      [translateTagY]="-50"
      [isAbsoluteElement]="true"></app-feature-tag>
  }
  @if (info.static?.height || info.autoScroll) {
    <app-modal-head
      [info]="info"
      [loadingInfo]="loadingInfo"
      [titleContent]="titleContent"
      [textContent]="textContent"
      [contentOnHeader]="contentOnHeader"
      (closeModal)="clickCloseModal($event)"></app-modal-head>
  } @else {
    <div class="modal__container" [class.column]="info.header?.withForm">
      <app-modal-head
        [info]="info"
        [loadingInfo]="loadingInfo"
        [titleContent]="titleContent"
        [textContent]="textContent"
        [contentOnHeader]="contentOnHeader"
        (closeModal)="clickCloseModal($event)"></app-modal-head>
      <ng-content></ng-content>
    </div>
  }
  @if (info.notScrollable) {
    <div class="scroll-wrapper scroll-wrapper--no-scroll">
      <div class="modal__container modal__container--flex">
        <ng-container [ngTemplateOutlet]="scrollableContent"></ng-container>
      </div>
    </div>
  }
  @if (!info.notScrollable && (info.static?.height || info.autoScroll)) {
    <div class="scroll-wrapper">
      <app-scrollbar class="scrollbar" [vertical]="true" [size]="'standard'">
        <div class="modal__container">
          <ng-container [ngTemplateOutlet]="scrollableContent"></ng-container>
        </div>
      </app-scrollbar>
    </div>
  }
  @if (info.actions) {
    <app-modal-actions
      [info]="info"
      [loadingInfo]="loadingInfo"
      [submitWithClothingContent]="submitWithClothingContent"
      [closeModalBtnContent]="closeModalBtnContent"
      [customActionBtnContent]="customActionBtnContent"
      [formUnchangedInfo]="formUnchangedInfo"
      (closeModal)="clickCloseModal($event)"
      (onSubmit)="clickOnSubmit()"></app-modal-actions>
  }
</div>
